<template>
  <v-container>
    <v-form ref="accountDetails">
      <v-row class="mt-3">
        <v-col lg="6" md="6" cols="12">
          <label class="required">Source Of Funds </label>

          <v-select
            v-model="sourceoffunds"
            placeholder="Source Of Funds"
            :items="sourceOfFundsList"
            :menu-props="{ bottom: true, offsetY: true }"
            item-text="text"
            item-value="value"
            required
            outlined
            dense
            :rules="FieldRequired('Source Of Funds')"
            class=""
          >
          </v-select>
        </v-col>
        <v-col lg="6" md="6" cols="12">
          <label class="required">Reason </label>
          <v-select
            v-model="reason"
            placeholder="Purpose of remittance"
            :items="purposeOfRemittenceList"
            :menu-props="{ bottom: true, offsetY: true }"
            required
            outlined
            dense
            class=""
            :rules="FieldRequired('Reason')"
          >
          </v-select>
        </v-col>
        <v-col cols="12" lg="6" md="6">
          <label class="required">Deposit Channel </label>
          <v-select
            v-model="deposit_channel"
            placeholder="Select Deposit Channel"
            :menu-props="{ bottom: true, offsetY: true }"
            :items="DepositChanels"
            outlined
            dense
            :rules="FieldRequired('Deposit Channel')"
          >
          </v-select
        ></v-col>

        <v-col lg="6" md="6" cols="12">
          <label>Remarks </label>
          <v-text-field
            v-model="accountDetails.remarks"
            placeholder="Remarks"
            required
            outlined
            dense
            class=""
          >
          </v-text-field
        ></v-col>

        <v-col cols="12" md="12">
          <v-btn
            class="float-left mt-5 px-5 btn-primary-outlined text-capitalize"
            @click="onClickBack"
            outlined
            ><v-icon dark left>mdi-arrow-left</v-icon> Back
          </v-btn>
          <v-btn
            class="float-right mt-5 px-5 btn-primary-outlined text-capitalize"
            @click="onclickNext"
            outlined
          >
            Next
            <v-icon dark right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '400',
        PicWidth: 500,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </v-container>
</template>

<script>
// import Loading from "vue-loading-overlay";
import imageViewer from "../../tools/imageViewer.vue";
import { FieldRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import { mapState } from "vuex";
import commonService from "@/services/AgentCommonService/commonService.js";
export default {
  name: "AccountSection",
  components: {
    // Loading,
    imageViewer,
  },
  data() {
    return {
      FieldRequired,
      filterNumberInput,
      sourceOfFundsList: [],
      DepositChanels: [],
      DepositChanelsobj: [],
      is_partner: false,
      user_type: "",
      imageData: {
        bankAdvice: [],
        bankAdviceUrl: "",
        custInvoice: [],
        custInvoiceUrl: "",
        businessInvoice: [],
        businessInvoiceUrl: "",
      },
      isImageViewer: false,
      imageViewerUrl: "",
      name: "",
      isSubmitted: false,
      // fullPage: true,
      height: 100,
      width: 100,
      paymentTypes: [],
      reason: "",
      sourceoffunds: "",
      deposit_channel: "",
      accountDetails: {
        payment_type: "",
        reason: "",
        reason_text: "",
        sourceoffunds: "",
        sourceoffund_text: "",
        deposit_channel_id: "",
        ledger_id: "",
        deposit_channel_text: "",
        remarks: "",
        bank_advice: [],
        cust_invoice: [],
        business_Invoice: [],
      },
      purposeOfRemittenceList: [],
      purposeOfRemittenceobj: [],
      sourceOfFundsobj: [],
      hidepaymentMode: true,
    };
  },
  // props: {
  //   self: {
  //     type: Boolean,
  //     default: true,
  //   },
  //   paymentDetails: {
  //     type: Object,
  //   },
  // },
  computed: {
    ...mapState(["userDetails"]),
  },
  mounted() {
    this.getSourceOfFunds();
    this.getPurposeOfRemittence();
    this.getDepositChannel();
    this.user_type = "IND";
    // validating partner user for mapping payment type
    if (this.is_partner) {
      this.paymentTypes = ["WALLET"];
      this.accountDetails.payment_type = "WALLET";
    } // validating partner user for mapping payment type
    else if (!["null", "", null, undefined].includes(this.user_type)) {
      this.paymentTypes = [
        "FPX (Internet Banking)",
        "E-Wallets",
        "Bank Transfer/Cash Deposit",
      ];
      this.accountDetails.payment_type = "FPX (Internet Banking)";
    }
    console.log("userDetails", this.userDetails);
    console.log(
      "this.accountDetails.payment_type",
      this.accountDetails.payment_type
    );
  },
  watch: {
    paymentDetails(val) {
      if (val) {
        this.accountDetails = { ...val };
      }
    },
    reason(val) {
      console.log("account details", val);
      this.purposeOfRemittenceobj.map((i) => {
        if (i.value === val) {
          this.accountDetails.reason = i.value_code;
          this.accountDetails.reason_text = i.value;
        }
      });
    },
    sourceoffunds(val) {
      console.log("sourceoffunds", val);
      this.sourceOfFundsobj.map((i) => {
        if (i.value === val) {
          this.accountDetails.sourceoffunds = i.value_code;
          this.accountDetails.sourceoffund_text = i.value;
        }
      });
    },
    deposit_channel(val) {
      console.log("sourceoffunds", val);
      this.DepositChanelsobj.map((i) => {
        if (i.channel_name === val) {
          this.accountDetails.deposit_channel_id = i.channel_id;
          this.accountDetails.deposit_channel_text = i.channel_name;
          this.accountDetails.ledger_id = i.ledger_id;
        }
      });
    },
  },
  methods: {
    open() {
      this.$refs.Bankadvice.$el.querySelector("input").click();
    },
    uploadCust() {
      this.$refs.custInvoice.$el.querySelector("input").click();
    },
    async getDepositChannel() {
      try {
        const responseData = await commonService.getDepositChannel();
        if (responseData.data.status_code === 200) {
          this.DepositChanels =
            responseData.data &&
            responseData.data.data.map((e) => e.channel_name);
          this.DepositChanelsobj =
            responseData.data && responseData.data.data.map((e) => e);
        }
        console.log("Deposit Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    async getPurposeOfRemittence() {
      try {
        const responseData = await commonService.getparameterdropdowns(
          "POR",
          this.$route.query.user_type_code
        );
        if (responseData.data.status_code === 200) {
          this.purposeOfRemittenceList =
            responseData.data && responseData.data.data.map((e) => e.value);
          this.purposeOfRemittenceobj =
            responseData.data && responseData.data.data.map((e) => e);
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getSourceOfFunds() {
      try {
        const responseData = await commonService.getparameterdropdowns(
          "SOF",
          this.$route.query.user_type_code
        );
        if (responseData.data.status_code === 200) {
          this.sourceOfFundsList =
            responseData.data && responseData.data.data.map((e) => e.value);
          this.sourceOfFundsobj =
            responseData.data && responseData.data.data.map((e) => e);
        }

        console.log("Funds", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    genrateURL(keyField, value, assignKey) {
      if (!keyField) return;
      if (!value) {
        this.imageData[`${keyField}`] = null;
        this.accountDetails[`${assignKey}`] = null;
      } else {
        this.imageData[`${keyField}`] = URL.createObjectURL(value);
        this.accountDetails[`${assignKey}`] = value;
      }
    },

    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    onclickNext() {
      const validate = this.$refs.accountDetails.validate();
      if (validate)
        this.$emit("onClickNext", { paymentDetails: this.accountDetails });
      console.log("this.accountDetails", this.accountDetails);
    },
    onClickBack() {
      this.$emit("onClickBack");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";
.required:after {
  content: " *";
  color: red;
}
.invalid-feedback-password {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.invalid-feedback-confirm {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
.invalid-feedback-swift {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
@media (min-width: 768px) {
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>
